export const userAssignedCardsIcons = {
  newsDefaultPictureGallery: 'assets/img/icon/econews/default-image-gallery-view.png',
  newsDefaultPictureList: 'assets/img/icon/econews/default-image-list-view.png',
  newsDefaultPictureProfile: 'assets/img/icon/econews/news-default-small.png',
  userIcon: 'assets/img/icon/econews/profile-icon.svg',
  calendarIcon: 'assets/img/icon/econews/calendar-icon.svg',
  locationIcon: 'assets/img/events/location.svg',
  clockIcon: 'assets/events-icons/clock.png'
};
